module.exports = __webpack_public_path__ + "media/images/lb/808-72849bc5ac6c2b115b5c7b9be4efbd04.svg";